import type { RtiFieldSection } from 'model/interfaces/rti-employee-data-fields';
import type { IRtiSettingsPersisted } from 'model/interfaces/settings';
import type { RtiTemplateData } from 'model/interfaces/rti-template';
import { RTI_TEMPLATE_VERSION_DEFAULT } from 'services/rti/get-rti-template';
import { normalizeCalculationMethodologyFromApi } from 'utilities/rti-calculation-methodology';
import { normalizeRtiCompanyWideReport } from 'utilities/rti-aggregated-compensation';
import {
  ensureRtiAggregatedCompensationSelection,
  ensureRtiComparisonGroupSelection,
  ensureRtiEmployeeDataFieldsSelection,
} from 'utilities/rti-template-field-selection';

export function rtiTemplateDataToSettingsPatch(d: RtiTemplateData): Partial<IRtiSettingsPersisted> {
  const canEdit = d.isEditAccess === true;
  const companyWideReport = normalizeRtiCompanyWideReport(d.company_wide_report);
  const compensation = ensureRtiAggregatedCompensationSelection(companyWideReport.compensation as RtiFieldSection);
  const companyWideReportWithSelection = { ...companyWideReport, compensation };
  const minimumDataThreshold =
    d.minimum_data_threshold &&
    typeof d.minimum_data_threshold === 'object' &&
    !Array.isArray(d.minimum_data_threshold)
      ? (d.minimum_data_threshold as Record<string, unknown>)
      : {};

  return {
    rtiReportHeader: d.report_header ?? '',
    rtiReportFooter: d.report_footer ?? '',
    rtiCalculationMethodology: normalizeCalculationMethodologyFromApi(
      d.calculation_methodology,
      d.calculation_methodology_labels,
    ),
    rtiTemplateVersion: d.template_version ?? d.template_version_param ?? RTI_TEMPLATE_VERSION_DEFAULT,
    rtiEmployeeDataFields: ensureRtiEmployeeDataFieldsSelection(d.employee_data_fields),
    rtiComparisonGroup: ensureRtiComparisonGroupSelection(d.comparison_group) as unknown as Record<string, unknown>,
    rtiAggregatedCompensation: compensation,
    rtiCompanyWideReport: companyWideReportWithSelection,
    rtiMinimumDataThreshold: minimumDataThreshold,
    rtiTemplateLoaded: true,
    rtiIsEditAccess: canEdit,
  };
}
